// 事件紀錄 V2 的 type，與後端 Service.Common/Models/EventRecordTypes.cs 一一對應，
// 括號內為對應的 V1 eventCode。Legacy_ 前綴是前端自用值：V1 有、V2 已移除的事件，
// 由 normalizeV1EventRecords 產生，後端不會送。
export enum EventRecordTypeEnum {
  // 選物販賣機
  prizeDispense = 'Meter_PrizeDispense', // 100 電眼出貨
  cashboxCollection = 'Op_CashboxCollection', // 110 錢箱收款
  remoteCoinInsert = 'Op_RemoteCoinInsert', // 111 補幣事件
  remotePrizeDispense = 'Op_RemotePrizeDispense', // 112 遠端測試

  // 兌幣機
  coinExchange = 'Meter_CoinExchange', // 101 出幣事件
  panelCoinDispense = 'Meter_PanelCoinDispense', // V1 沒有，手動面板退幣
  stockAdjustment = 'Meter_StockAdjustment', // 214 手動庫存更改
  payoutReset = 'Meter_PayoutReset', // 215 手動已兑歸零
  remoteCoinDispense = 'Op_RemoteCoinDispense', // 210 退幣事件
  remoteUnlockWindow = 'Op_RemoteUnlockWindow', // 211 關閉保全功能
  remoteUnlock = 'Op_RemoteUnlock', // 212 遠端開鎖
  remoteRestart = 'Op_RemoteRestart', // 213 遠端故障消除
  doorOpenedOrClosed = 'Sys_CoinMachineDoorOpenedOrClosed', // 501 兌幣機開關門

  // 共用
  connected = 'Sys_Connected', // 0 機台連線
  connectionTimeout = 'Sys_ConnectionTimeout', // -1 機台斷線

  // 僅 V1 會出現
  legacyStockReport = 'Legacy_StockReport', // 102 庫存回報
  legacyStatusReport = 'Legacy_StatusReport', // 103 狀態回報
  legacyMachineMalfunction = 'Legacy_MachineMalfunction' // 4 機台故障
}
